import { Component } from 'react'
import { Container, Row, Col } from "react-bootstrap"
import 'bootstrap/dist/css/bootstrap.min.css'
import { reactLocalStorage } from "reactjs-localstorage"

import withRouter from "../../util/WithRouter"
import Util from "../../util/Util"
import LeadConst from "../../util/LeadConst"
import Const from "../../util/Constants"
import PropertyConst from "../../util/PropertyConst";
import Display from "../../util/Display"
import ApiUiController from "../../controller/ApiUiController"
import LeadPreviewPopUpList from "./LeadPreviewPopUpList"

// Import modern design components
import HeaderActions from './component/HeaderActions'
import StatusPipeline from './component/StatusPipeline'
import LeadInfoSidebar from './component/LeadInfoSidebar'
import MainContentTabs from './component/MainContentTabs'
import PropertiesSidebar from './component/PropertiesSidebar'

import LeadAPI from '../../api/LeadAPI'
import RestrictedAccess from '../RestrictedAccess'

class LeadPrevDesign4 extends Component {
  constructor(props) {
    super(props)

    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.lead;
    this.ProgressOptions = this.model.fields.progress.options;
    this.id = parseInt(props.match.params.leadId);
    this.options = [{ label: 'Tab View', value: 1 }, { label: 'List View', value: 2 }, { label: 'Compact', value: 3 }, { label: 'Modern', value: 4 }];
    const query = new URLSearchParams(props.location.search);
    this.iItem = query.get("indx") ? parseInt(query.get("indx")) : 0;
    this.lItem = query.get("size") ? parseInt(query.get("size")) : 0;
    const isNext = this.iItem !== 0 && this.lItem !== 0;

    this.isEnterprise = this.user.package === Const.PackageEnterprise;
    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.indexOf("/preview"));
    this.editLink = `${this.base}/add-edit/${this.id}${isNext ? `?indx=${this.iItem}&size=${this.lItem}` : ""}`;

    // Design options
    this.options = [
      { label: 'Tab View', value: 1 }, 
      { label: 'List View', value: 2 }, 
      { label: 'Compact', value: 3 }, 
      { label: 'Modern', value: 4 }
    ];

    // Get current design option
    const LeadTheam = reactLocalStorage.get(Const.LeadTheme)
      ? parseInt(reactLocalStorage.get(Const.LeadTheme))
      : Const.LeadTheme;
    this.designOption = this.options.find(
      (opt) => opt.value === LeadTheam
    );

    // Set permissions
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.CallAdd = Util.isAllow(this.models.call.permission, Const.PermAdd);
    this.MeetAdd = Util.isAllow(this.models.meeting.permission, Const.PermAdd);
    this.Property = Util.isAllow(this.models.property.permission, Const.PermView);
    this.DocAdd = Util.isAllow(this.models.document.permission, Const.PermAdd);
    this.SmsAdd = Util.isAllow(this.models.sms.permission, Const.PermAdd);
    this.whatsAppAdd = Util.isAllow(this.models.whatsapp.permission, Const.PermAdd);
    this.NoteAdd = Util.isAllow(this.models.note.permission, Const.PermAdd);
    this.EmailAdd = Util.isAllow(this.models.email.permission, Const.PermAdd);
    this.SalesAdd = Util.isAllow(this.models.sales_order.permission, Const.PermAdd);
    this.ContactAdd = Util.isAllow(this.models.contact.permission, Const.PermAdd);
    this.LeadPreviewRestrict = Util.isAllow(this.model.permission, Const.PermLeadPreviewRestrict);
    
    // Cloud calling
    this.CloudCall = reactLocalStorage.getObject(Const.CloudCalling);
    this.CloudCall = this.CloudCall && Object.keys(this.CloudCall).length > 0 ? this.CloudCall : null;

    this.state = {
      inApiCall: false, // Set to false since we're using static data
      popup: null,
      call: null,
      task: null,
      ticket: null,
      meeting: null,
      document: null,
      note: null,
      email: 0,
      sms: 0,
      whatsApp: 0,
      contacts: [],
      change: false,
      // Use static data
      activeTab: "timeline",
      showActionMenu: false,
      showDesignMenu: false,
    };

    this.onProperties = () => {
      const lead = this.lead;
      const filter = [];
      const fields = this.models.property.fields;
      const SearchProperty = ['price', 'property_transaction', 'property_is', 'property_type', 'area'];
      for (let i = 0; i < SearchProperty.length; i++) {
        const field = SearchProperty[i];
        if (!fields[field]) {
          continue;
        }
        const type = fields[field].field_type;
        if (type === Const.Number || type === Const.Decimal) {
          if (field === PropertyConst.Price) {
            if (lead.min_budget && lead.max_budget) {
              filter.push({
                field,
                type,
                condition: "in",
                value: `${lead.min_budget}~${lead.max_budget}`,
              });
            } else if (lead.min_budget) {
              filter.push({
                field,
                type,
                condition: "start-with",
                value: `${lead.min_budget}~`,
              });
            } else if (lead.max_budget) {
              filter.push({
                field,
                type,
                condition: "end-with",
                value: `~${lead.max_budget}`,
              });
            }
          } else if (lead[field]) {
            filter.push({
              field,
              type,
              condition: "start-with",
              value: `${lead[field]}~`,
            });
          }
        } else if (type.includes(Const.Select) && lead[field]) {
          const value =
            typeof lead[field] === "string" && lead[field].includes(Const.Opt)
              ? lead[field]
              : `~${lead[field]}~`;
          filter.push({ field, type, condition: "in", value });
        }
      }
      this.props.navigate(`/property?filters=${JSON.stringify(filter)}`);
    };
  }
  
  UNSAFE_componentWillReceiveProps(props) {
    if (this.id !== parseInt(props.match.params.leadId)) {
      this.id = parseInt(props.match.params.leadId);
      let dummy = { ...this.state };
      if (dummy.call) {
        dummy.call.model_no = Const.Lead;
        dummy.call.model_id = this.id;
      }
      if (dummy.task) {
        dummy.task.model_no = Const.Lead;
        dummy.task.model_id = this.id;
      }
      if (dummy.ticket) {
        dummy.ticket.model_no = Const.Lead;
        dummy.ticket.model_id = this.id;
      }
      if (dummy.meeting) {
        dummy.meeting.model_no = Const.Lead;
        dummy.meeting.model_id = this.id;
      }
      if (dummy.document) {
        dummy.document.model_no = Const.Lead;
        dummy.document.model_id = this.id;
      }
      if (dummy.email) {
        dummy.email.model_no = Const.Lead;
        dummy.email.model_id = this.id;
      }
      if (dummy.sms) {
        dummy.sms.model_no = Const.Lead;
        dummy.sms.model_id = this.id;
      }
      this.setState({ ...dummy });
      this.editLink = `${this.base}/add-edit/${this.id}`;
      this.iItem = 0;
      this.lItem = 0;
      LeadAPI.get(this.id, this.onReceived, this.onFail);
    }
  }

  componentDidMount() {
    if (this.id !== 0) {
      LeadAPI.get(this.id, this.onReceived, this.onFail);
    }
  }

  onFail = (res) => {
    const message = res && res.message ? res.message : 'Failed to save call';
    this.setState({ ...this.state, inApiCall: false });
    Util.showError(message);
  };

  onReceived = (res) => {
    this.lead = res;
    const SmsAdd = Util.isAllow(this.models.sms.permission, Const.PermAdd);
    const SmsOpt =
      this.lead && this.lead.sms_opt && this.lead.sms_opt === Const.True;
    this.SmsAdd = SmsAdd && !SmsOpt;

    const EmailOpt =
      this.lead && this.lead.email_opt && this.lead.email_opt === Const.True;
    const EmailAdd = Util.isAllow(this.models.email.permission, Const.PermAdd);
    this.EmailAdd = EmailAdd && !EmailOpt;

    this.setState({ ...this.state, inApiCall: false });
  };

  updateMater = () => {
    this.setState({ inApiCall: true, popup: null });
    LeadAPI.get(this.id, this.onReceived, this.onFail);
  };

  onPrev = () => this.props.navigate(`/lead/next-prev/${this.iItem - 1}`);
  onNext = () => this.props.navigate(`/lead/next-prev/${this.iItem + 1}`);

  // Popup handlers
  showPopUp = (model, field) => {
    if (field === LeadConst.SalesOrder) {
      this.props.navigate(`/sales-order/add-edit/1/${this.id}/0`);
      return;
    } else if (field === LeadConst.Quote) {
      this.props.navigate(`/quote/add-edit/1/${this.id}/${model}`);
      return;
    } else if (field === LeadConst.History) {
      this.props.navigate(`/lead/history/${this.id}`);
      return;
    } else if (field === LeadConst.Edit) {
      // Edit link
      const base = this.props.match.path;
      const editBase = base.substring(0, base.indexOf("/preview"));
      const editLink = `${editBase}/add-edit/${this.id}`;
      this.props.navigate(editLink);
      return;
    } else if (field === LeadConst.Delete) {
      this.onDelete();
      return;
    }
    
    // For other popups
    let tmp = { ...this.state };
    tmp[field] = model;
    tmp.popup = field;
    this.setState({ ...tmp });
  };

  onDelete = () => {
    Util.confirmAlert(
      "Delete",
      `Are you sure you want to delete ${Display.ModelName(this.lead)}`,
      "Delete",
      "No",
      () => {
        this.setState({ ...this.state, inApiCall: true });
        LeadAPI.delete(this.lead.id, this.onDeleteSuccess, this.onFail);
      }
    );
  };
  onDeleteSuccess = () => {
    Util.showNotification("Successful", "Lead deleted successfully", "success");
    this.props.navigate("/lead");
  };

  hidePopUp = () => this.setState({ ...this.state, popup: null });

  onDesignChange = (option) => {
    this.designOption = option;
    reactLocalStorage.set(Const.LeadTheme, option.value);
    this.props.onModuleChanged && this.props.onModuleChanged();
  };

  // Tab and menu handlers
  setActiveTab = (tab) => {
    this.setState({ activeTab: tab })
  }

  toggleActionMenu = () => {
    this.setState(prevState => ({
      showActionMenu: !prevState.showActionMenu
    }))
  }

  toggleDesignMenu = () => {
    this.setState(prevState => ({
      showDesignMenu: !prevState.showDesignMenu
    }))
  }

  handleStatusChange = (statusIndex) => {
    const updatedStatus = this.state.statusPipeline.map((item, index) => ({
      ...item,
      current: index === statusIndex,
      completed: index <= statusIndex
    }))
    this.setState({ statusPipeline: updatedStatus })
  }

  handleAddActivity = (activity) => {
    this.setState(prevState => ({
      timeline: [activity, ...prevState.timeline]
    }))
  }

  showDetails = (model, field) => {
    if (field === LeadConst.SalesOrder) {
      this.props.navigate(`/sales-order/preview/${model}`);
      return;
    } else if (field === LeadConst.Quote) {
      this.props.navigate(`/quote/preview/${model}`);
      return;
    } else if (field === LeadConst.Contact) {
      this.props.navigate(`/contact/preview/${model}`);
      return;
    }
  };

  render() {
    const { 
      popup, 
      activeTab, 
      showActionMenu, 
      showDesignMenu, 
    } = this.state;

    if(!this.lead) return null;
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        {/* Popup component */}
        <LeadPreviewPopUpList
          popup={popup}
          hidePopUp={this.hidePopUp}
          updateMater={this.updateMater} 
          model={this.model}
          module={Const.Lead}
          id={this.id}
          NoteAdd={this.NoteAdd}
          CallAdd={this.CallAdd}
          CallUpdate={this.CallUpdate}
          call={this.state.call}
          TaskAdd={this.TaskAdd}
          TaskUpdate={this.TaskUpdate}
          task={this.state.task}
          TicketAdd={this.TicketAdd}
          TicketUpdate={this.TicketUpdate}
          ticket={this.state.ticket}
          EmailAdd={this.EmailAdd}
          MeetAdd={this.MeetAdd}
          MeetUpdate={this.MeetUpdate}
          meeting={this.state.meeting}
          SmsAdd={this.SmsAdd}
          DocAdd={this.DocAdd}
          document={this.state.document}
          ContactAdd={this.ContactAdd}
          whatsAppAdd={this.whatsAppAdd}
          contacts={this.state.contacts}
          lead={this.lead}
          note={this.state.note}
          redirectAddContact={this.redirectAddContact}
          addContact={this.addContact}
          CloudCall={this.CloudCall}
          CallCloudCall={this.state.CloudCall}
          showPopUp={this.showPopUp}
        />
        
        {!((this.lead?.responsible_person ?? '').includes(this.user?.user_id ?? 0)) && this.LeadPreviewRestrict ? (
          <RestrictedAccess />
        ) : (
          <div style={{ minHeight: '100vh', backgroundColor: 'white' }}>
            <Container fluid style={{padding: '8px' }}>
              <Row>
                {/* LEFT COLUMN: Lead Info Sidebar */}
                <Col md={3} style={{paddingRight: 8, paddingLeft: 15}}>
                  <LeadInfoSidebar 
                    lead={this.lead}
                    onUpdateLead={() => {}} // Empty function for static data
                  />
                </Col>

                {/* RIGHT COLUMN: Main content */}
                <Col md={9} style={{paddingLeft: 0}}>
                  {/* Header Actions Row */}
                  <Row>
                    <Col md={12}>
                      <HeaderActions 
                        // State props
                        showActionMenu={showActionMenu}
                        showDesignMenu={showDesignMenu}
                        
                        // Toggle handlers
                        onToggleActionMenu={this.toggleActionMenu}
                        onToggleDesignMenu={this.toggleDesignMenu}
                        onAddActivity={this.handleAddActivity}
                        
                        // Data props
                        lead={this.lead}
                        iItem={this.iItem}
                        lItem={this.lItem}
                        models={this.models}
                        option={this.designOption}
                        
                        // Permission props
                        NoteAdd={this.NoteAdd}
                        CallAdd={this.CallAdd}
                        MeetAdd={this.MeetAdd}
                        Property={this.Property}
                        Update={this.Update}
                        Delete={this.Delete}
                        CloudCall={this.CloudCall}
                        EmailAdd={this.EmailAdd}
                        DocAdd={this.DocAdd}
                        SmsAdd={this.SmsAdd}
                        SalesAdd={this.SalesAdd}
                        QuoteAdd={this.QuoteAdd}
                        ContactAdd={this.ContactAdd}
                        
                        // Action handlers
                        onPrev={this.onPrev}
                        onNext={this.onNext}
                        onDesignChange={this.onDesignChange}
                        onProperties={this.onProperties}
                        showPopUp={this.showPopUp}
                      />
                    </Col>
                  </Row>

                  {/* Status Pipeline Row */}
                  <Row className="mb-2">
                    <Col md={12}>
                      <StatusPipeline 
                        statusItems={this.ProgressOptions}
                        onStatusChange={this.handleStatusChange}
                        progress={this.lead ? this.lead['progress'] : 0} 
                      />
                    </Col>
                  </Row>

                  {/* Main Content Row */}
                  <Row>
                    <Col md={8}>
                      <MainContentTabs 
                        id={this.id}
                        type={Const.Lead}
                        lead={this.lead}
                        activeTab={activeTab}
                        onTabChange={this.setActiveTab}
                        edit={this.showPopUp}
                        model={this.models}
                        cloud_call={this.CloudCall}
                        onCloudeCall={this.showPopUp}
                        show={this.showDetails}
                        reload={this.updateMater}
                      />
                    </Col>
                    {
                      this.Property ? (
                        <Col md={4} style={{paddingLeft: 0}}>
                          <PropertiesSidebar
                            {...this.props}
                            id={this.id}
                            type={Const.Lead}
                            lead={this.lead}
                            activeTab={activeTab}
                            onTabChange={this.setActiveTab}
                            edit={this.showPopUp}
                            model={this.models}
                            cloud_call={this.CloudCall}
                            onCloudeCall={this.showPopUp}
                            show={this.showDetails}
                            reload={this.updateMater}
                          />
                        </Col>
                      ) : null
                    }
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </ApiUiController>
    )
  }
}

export default withRouter(LeadPrevDesign4)